/**
 * damage_hooks — the one seam a low-level VFX file reports into the persistent-damage runtime through (shader gaps R2).
 * `explosion_fx.ts` is bundled by pure node harnesses (`verify:fire`, `verify:explosion-sound-delay`); importing the
 * runtime would drag the game state into them. The runtime installs the hook at boot; until then (and in a harness)
 * a report is a no-op.
 */
export const damageHooks: { blast: ((x: number, y: number, z: number, scale: number) => void) | null } = { blast: null };

/** A staged explosion at an ABSOLUTE point (once per blast). */
export function reportBlast(x: number, y: number, z: number, scale: number): void {
  try { damageHooks.blast?.(x, y, z, scale); } catch { /* presentation only — never throw into a VFX path */ }
}
